import { makeActionCreator } from '../../../config/store/utils';
import { getState } from '../../../services/security';


export const GET_STATE_ADAS = 'GET_STATE_ADAS';
export const GET_STATE_ADAS_ERROR = 'GET_STATE_ADAS_ERROR';
export const GET_STATE_ADAS_SUCCESS = 'GET_STATE_ADAS_SUCCESS';
export const onGetStateAdas = makeActionCreator(GET_STATE_ADAS);
export const onGetStateAdasError = makeActionCreator(
    GET_STATE_ADAS_ERROR,
    'payload'
);
export const onGetStateAdasSuccess = makeActionCreator(
    GET_STATE_ADAS_SUCCESS,
    'payload'
);

// Modificar el `onGetAsarcoThunk` para recibir el parámetro `shift`.
export const onGetStateAdasThunk = () => async dispatch => {
    dispatch(onGetStateAdas());
    try {
        // Llamar a la API y obtener los datos
        const { data } = await getState();
        
        // Acceder a datos_historicos que es donde está el array
        const datosHistoricos = data.datos_historicos || [];

        const state = datosHistoricos.map((item, index) => ({
            ...item,
            id: `${index + 1}`,
        }));

        return dispatch(
            onGetStateAdasSuccess({
                lista: state,
            })
        );
    } catch (error) {
        console.log(error);
        return dispatch(
            onGetStateAdasError({
                error: error,
            })
        );
    }
};